import * as Yup from "yup";

export const initialValues = {
  name: "", email: "", password: "", profile: "user", profileImage: null,
  startWork: "00:00", endWork: "23:59", farewellMessage: "", allTicket: "disable", allowGroup: false,
  defaultTheme: "light", defaultMenu: "open", allHistoric: "disabled", allUserChat: "disabled",
  userClosePendingTicket: "enabled", showDashboard: "disabled", allowRealTime: "disabled", allowConnections: "disabled",
  whatsappId: "", queueIds: []
};
export const permissions = [
  { name: "allTicket", label: "Ver atendimentos sem fila", enabled: "enable", disabled: "disable" },
  { name: "allowGroup", label: "Atender grupos", enabled: true, disabled: false },
  { name: "allHistoric", label: "Ver conversas de outras filas", enabled: "enabled", disabled: "disabled" },
  { name: "allUserChat", label: "Ver conversas de outros usuários", enabled: "enabled", disabled: "disabled" },
  { name: "userClosePendingTicket", label: "Encerrar atendimentos aguardando", enabled: "enabled", disabled: "disabled" },
  { name: "allowConnections", label: "Gerenciar conexões", enabled: "enabled", disabled: "disabled" },
  { name: "showDashboard", label: "Ver painel de indicadores", enabled: "enabled", disabled: "disabled" },
  { name: "allowRealTime", label: "Ver painel de atendimentos", enabled: "enabled", disabled: "disabled" }
];

export const normalizeUser = data => {
  const values = { ...initialValues };
  Object.keys(initialValues).forEach(key => { if (data[key] !== null && data[key] !== undefined) values[key] = data[key]; });
  return { ...values, password: "", whatsappId: data.whatsappId || "", queueIds: (data.queues || []).map(queue => queue.id) };
};

export const userSchema = (creating, administrator = true) => Yup.object({
  name: Yup.string().trim().min(2, "Use pelo menos 2 caracteres.").max(50, "Use até 50 caracteres.").required("Informe o nome."),
  email: Yup.string().trim().email("Informe um e-mail válido.").required("Informe o e-mail."),
  password: creating ? Yup.string().min(5, "Use pelo menos 5 caracteres.").max(50, "Use até 50 caracteres.").required("Informe uma senha.") : Yup.string().transform(value => value || undefined).min(5, "Use pelo menos 5 caracteres.").max(50, "Use até 50 caracteres."),
  ...(administrator ? { startWork: Yup.string().matches(/^([01]\d|2[0-3]):[0-5]\d$/, "Informe um horário válido.").required("Informe o horário."),
  endWork: Yup.string().matches(/^([01]\d|2[0-3]):[0-5]\d$/, "Informe um horário válido.").required("Informe o horário.") } : {})
});

export const userPayload = (values, administrator) => {
  const personal = ["name", "email", "farewellMessage", "defaultTheme", "defaultMenu", "profileImage"];
  const keys = administrator ? Object.keys(initialValues).filter(key => key !== "password") : personal;
  const payload = {};
  keys.forEach(key => { payload[key] = values[key]; });
  payload.name = values.name.trim(); payload.email = values.email.trim();
  if (values.password) payload.password = values.password;
  if (administrator) payload.whatsappId = values.whatsappId || null;
  return payload;
};
